import axios from "axios";

// Production build (Hostinger): same-origin /api -> PHP backend.
// Dev/preview (yarn start): uses REACT_APP_BACKEND_URL -> preview backend.
export const API =
  (process.env.NODE_ENV === "production"
    ? ""
    : process.env.REACT_APP_BACKEND_URL || "") + "/api";

const TOKEN_KEY = "gl_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";

export const setToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/** URL-safe slug from a product name: "Moon Socket Lamp" -> "moon-socket-lamp". */
export function slugify(text) {
  return String(text || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** Turn a stored image path into a loadable URL (works for uploads and absolute URLs). */
export function imgUrl(path) {
  if (!path) return "";
  if (/^https?:\/\//.test(path)) return path;
  const base =
    process.env.NODE_ENV === "production"
      ? ""
      : process.env.REACT_APP_BACKEND_URL || "";
  return `${base}/${path.replace(/^\//, "")}`;
}

/** Normalize an API product into the shape the public site components use. */
export function normalizeProduct(p) {
  const images = Array.isArray(p.images) && p.images.length
    ? p.images.map((i) => ({ path: imgUrl(i.path), is_primary: !!i.is_primary }))
    : p.image
      ? [{ path: imgUrl(p.image), is_primary: true }]
      : [];
  return {
    id: String(p.id),
    name: p.name,
    slug: slugify(p.name),
    category: p.category,
    categories: Array.isArray(p.categories) && p.categories.length
      ? p.categories
      : p.category
        ? [p.category]
        : [],
    price: p.price,
    description: p.description || "",
    longDescription: p.long_description || "",
    details: Array.isArray(p.details) ? p.details : [],
    image: images[0]?.path || "",
    images,
    video: p.video ? imgUrl(p.video) : "",
    videoPath: p.video || "",
    alt: p.name,
    created_at: p.created_at || "",
  };
}

/** Parse a display price like "₹1,999" into a number for filtering/sorting. */
export function parsePrice(price) {
  const n = parseInt(String(price || "").replace(/[^\d]/g, ""), 10);
  return Number.isNaN(n) ? 0 : n;
}
